import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { Location } from '@angular/common';
import { switchMap } from 'rxjs/operators';
import { HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
import { Title } from '@angular/platform-browser';

import { environment } from '../../environments/environment';
import { IRoughcheck, ISection } from '../roughcheck';
import { MessageService } from '../message.service';
import { RoughcheckService } from '../roughcheck.service';
import { LoggerService } from '../logger.service';

@Component({
  selector: 'app-sections',
  templateUrl: './sections.component.html',
})
export class SectionsComponent implements OnInit {

  roughcheck: IRoughcheck = {
    rref: '',
    title: '',
    image: '',
    image_alt: '',
    category: '',
    riskprofile: '',
    rewardprofile: '',
    show_risk_reward: 1,
    description: '',
    slug: '',
    status: 0,
    status_email: 0,
    feedback: 0,
    sponsor: '',
    website: ''
  };
  sections: ISection[];
  selectedSection: ISection = {
    id: '',
    title: '',
    description: '',
  };
  sectionList = new FormArray([]);

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private service: RoughcheckService,
    private location: Location,
    private message: MessageService,
    private logger: LoggerService,
    private title: Title
  ) {
      this.service.roughcheckRRef.subscribe(
        {
          next: (v) => {
            this.loadSections();
          }
        });
  }

  ngOnInit() {
    this.title.setTitle( 'Roughcheck sections' );
    this.roughcheck = this.service.getRoughcheck();
    if (! this.roughcheck.rref) {
      this.service.gotoFromUrl('sections', this.route.snapshot);
      return;
    }
  }

  loadSections() {
    this.sections = this.service.getSections();
    this.selectedSection = this.service.getSection();
  }

  /**
   * Compare section ids
   */
  compareSectionFn(s1: any, s2: any): boolean {
    return false;
  }

  onSelect(data: ISection): void {
    this.selectedSection = data;
    this.service.setSection(data);
  }

  /**
   * Select the next section
   * wrapping as necessary
   */
  sectionNext(): void {
    // Ignore if there aren't any
    if (this.sections.length === 0) {
      return;
    }

    // Arrays are 0 based
    for (let i = 0; i < this.sections.length; i++) {
      if (this.selectedSection.id === this.sections[i].id) {
        if (i === this.sections.length - 1) {
          // Go to the first
          this.selectedSection = this.sections[0];
          this.service.setSection(this.selectedSection);
          break;
        } else {
          // Go to next
          this.selectedSection = this.sections[i + 1];
          this.service.setSection(this.selectedSection);
          break;
        }
      }
    }
  }
  /**
   * Select the next section
   * wrapping as necessary
   */
  sectionPrev(): void {
    // Ignore if there aren't any
    if (this.sections.length === 0) {
      return;
    }

    // Arrays are 0 based
    for (let i = this.sections.length - 1; i >= 0; i--) {
      if (this.selectedSection.id === this.sections[i].id) {
        if (i === 0) {
          // Go to the last
          this.selectedSection = this.sections[this.sections.length - 1];
          this.service.setSection(this.selectedSection);
          break;
        } else {
          // Go to previous
          this.selectedSection = this.sections[i - 1];
          this.service.setSection(this.selectedSection);
          break;
         }
      }
    }
  }

  /**
   * Go to previous
   * If first section go to assessment page
   * else go to previous section
   */
  goPrevious() {
    if (this.selectedSection.id === this.sections[0].id) {
      this.router.navigate(['/a', this.service.getRRef(), this.service.getARef(), 'assessment']);
    } else {
      this.sectionPrev();
    }
  }
  /**
   * Go to next
   * If last section go to report page
   * else go to next section
   */
  goNext() {
    if (this.selectedSection.id === this.sections[this.sections.length - 1].id) {
      this.router.navigate(['/a', this.service.getRRef(), this.service.getARef(), 'report']);
    } else {
      this.sectionNext();
    }
  }

}
